import { render } from "./CodeBackground.vue?vue&type=template&id=32255f15"
import script from "./CodeBackground.vue?vue&type=script&lang=js"
export * from "./CodeBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__